/**
 * Controls sidebar open/close behaviour on mobile viewports.
 *
 * Replaces the former Bootstrap offcanvas integration with a pure
 * reactive approach: the sidebar is shown/hidden via a CSS translate
 * controlled by a boolean prop, and body scroll is locked while open.
 */
export const useMobileBehaviour = (
  isOpened: Ref<boolean>,
  emit: (e: 'update:isOpened', value: boolean) => void,
) => {
  const route = useRoute();
  const breakpoints = useAppBreakpoints();

  const closeSidebar = () => {
    if (!isOpened.value) return;
    emit('update:isOpened', false);
  };

  // Lock body scroll while the mobile sidebar is open
  const scrollLock = useScrollLock(import.meta.client ? document.body : null);
  watch(isOpened, (open) => {
    scrollLock.value = open;
  });

  // Close sidebar when navigating to a new page
  watch(() => route.path, closeSidebar);

  // Close sidebar when viewport crosses above xl breakpoint
  throttledWatch(
    breakpoints.greater('xl'),
    () => {
      closeSidebar();
    },
    { throttle: 200 },
  );
};
